import React from 'react';
import axios from 'axios';
import { handleJoinRequiresAbonement } from './abonementWizardEvents';

// Импорт всех компонентов
import Player from './Player';
import TimeSelectionModal from './TimeSelectionModal';
import PlayerPair from './PlayerPair';
import EmptyPlayer from './EmptyPlayer';
import EmptyPlayerSlot from './EmptyPlayerSlot';
import PlayersCount from './PlayersCount';
import PlayersCountNoNum from './PlayersCountNoNum';
import PlayersInner from './PlayersInner';
import PlayerInner from './PlayerInner';
import PlayersList from './PlayersList';
import PlayersPairs from './PlayersPairs';
import NoPlayersMessage from './NoPlayersMessage';
import ActionButton from './ActionButton';
import LoginButton from './LoginButton';
import NoActionButton from './NoActionButton';
import GameDetailsInnerRoot from './GameDetailsInnerRoot';
import GamePlayers from './GamePlayers';
import KingOfTheHillPlayers from './KingOfTheHillPlayers';
import KingOfTheHillResults from './KingOfTheHillResults';
import KingOfTheHillPrePlayers from './KingOfTheHillPrePlayers';
import MorningOpenPlayers from './MorningOpenPlayers';
import MorningOpenPrePlayers from './MorningOpenPrePlayers';
import RandomRelationsPlayers from './RandomRelationsPlayers';
import RandomRelationsResults from './RandomRelationsResults';
import RandomRelationsPrePlayers from './RandomRelationsPrePlayers';
import RandomRelationsMiniPlayers from './RandomRelationsMiniPlayers';
import TrainingQueue from './TrainingQueue';
import GameDetailsInnerSummary from './GameDetailsInnerSummary';
import AlertInfo from './AlertInfo';
import AlertDanger from './AlertDanger';
import AlertPrepayment from './AlertPrepayment';
import AlertAfterReg from './AlertAfterReg';
import AlertTraining from './AlertTraining';
import GameDetails from'./GameDetails';
import EmailPopupModal from './EmailPopupModal';
import GuestBookingForm from './GuestBookingForm';


// Экспорт всех компонентов
export {
  Player,
  PlayerPair,
  EmptyPlayer,
  EmptyPlayerSlot,
  PlayersCount,
  PlayersCountNoNum,
  PlayersInner,
  PlayerInner,
  PlayersList,
  PlayersPairs,
  NoPlayersMessage,
  ActionButton,
  LoginButton,
  NoActionButton,
  GameDetailsInnerRoot,
  GamePlayers,
  KingOfTheHillPlayers,
  KingOfTheHillResults,
  KingOfTheHillPrePlayers,
  MorningOpenPlayers,
  MorningOpenPrePlayers,
  RandomRelationsPlayers,
  RandomRelationsResults,
  RandomRelationsPrePlayers,
  RandomRelationsMiniPlayers,
  TrainingQueue,
  GameDetailsInnerSummary,
  AlertInfo,
  AlertDanger,
  AlertPrepayment,
  AlertAfterReg,
  AlertTraining,
  EmailPopupModal,
  GuestBookingForm,
  TimeSelectionModal
};

function parseJsonData(value, fallback) {
    if (!value) {
        return fallback;
    }

    try {
        return JSON.parse(value);
    } catch (error) {
        console.warn('Invalid game card JSON data:', error);
        return fallback;
    }
}

function parseIntData(value, fallback = 0) {
    const parsed = parseInt(value, 10);
    return Number.isNaN(parsed) ? fallback : parsed;
}

document.querySelectorAll('.slots__item')
  .forEach(domContainer => {
    try {

    let game = {
        timeFrame: domContainer.dataset.timeframe,
        eventType: domContainer.dataset.eventtype,
        gameType: domContainer.dataset.gametype,
        buttonMessage: domContainer.dataset.buttonmessage,
        playingField: domContainer.dataset.playingfield,
        weather: parseJsonData(domContainer.dataset.weather, null),
        isMenLimited: (domContainer.dataset.ismenlimited == 'True' ? true : false),
        isWomenLimited: (domContainer.dataset.iswomenlimited == 'True' ? true : false),
        skill: domContainer.dataset.skill,
        coach: domContainer.dataset.coach,
        price: domContainer.dataset.price,
        status: domContainer.dataset.status,
        email: domContainer.dataset.email,
        userid: domContainer.dataset.userid,
        lastname: domContainer.dataset.lastname,
        is_online_payment: domContainer.dataset.isonlinepayment,
        cardPrice: domContainer.dataset.cardprice,
        id: domContainer.dataset.gameid,
        numberOfPlayers: parseIntData(domContainer.dataset.numberofplayers),
        totalPlayersNum: parseIntData(domContainer.dataset.totalplayersnum),
        totalPlayersWithPaymentNum: parseIntData(domContainer.dataset.totalplayerswithpaymentnum),
        isUser: (domContainer.dataset.isuser == 'True' ? true : false),
        isJoiningAvailable: (domContainer.dataset.isjoinavailable == 'True' ? true : false),
        canRequestTrainingLevelApproval: (domContainer.dataset.canrequesttraininglevelapproval == 'True' ? true : false),
        isUserJoined: (domContainer.dataset.isuserjoined == 'True' ? true : false),
        isUserFriendJoined: (domContainer.dataset.isuserfriendjoined == 'True' ? true : false),
        isUserPaid: (domContainer.dataset.isuserpaid == 'True' ? true : false),
        isTraining: (domContainer.dataset.istraining == 'True' ? true : false),
        isTrainingAdminJoiningAvailable: (domContainer.dataset.isadminjoiningavailable == 'True' ? true : false),
        isKingOfTheHill: (domContainer.dataset.iskingofthehill == 'True' ? true : false),
        isRandomRelations: (domContainer.dataset.israndomrelations == 'True' ? true : false),
        isMorningOpen: (domContainer.dataset.ismorningopen == 'True' ? true : false),
        name: domContainer.dataset.name,
        isofferaccepted: domContainer.dataset.offer,
        players: parseJsonData(domContainer.dataset.players, []),
        emptySlotsNum: function() {
            //console.log('numberOfPlayers'+this.numberOfPlayers)
            //console.log('totalPlayersNum'+this.totalPlayersNum)
            return this.numberOfPlayers - this.totalPlayersNum
        }
    };

    ReactDOM.render(
        <GameDetails game={game} />,
        domContainer
    );
    } catch (error) {
        console.error('Failed to render game card:', domContainer.dataset.gameid, error);
    }

  });

function getListingOsAndSource() {
    const userAgent = navigator.userAgent;
    let operating_system = null;
    let source = 'website';

    if (/Android/i.test(userAgent)) {
        operating_system = 'android';
    } else if (/iPhone|iPad|iPod/i.test(userAgent)) {
        operating_system = 'ios';
    } else if (/Mac OS/i.test(userAgent)) {
        operating_system = 'macos';
    } else if (/Windows/i.test(userAgent)) {
        operating_system = 'windows';
    } else if (/Linux/i.test(userAgent)) {
        operating_system = 'linux';
    }

    if (/Mobile/i.test(userAgent) && !/iPad/i.test(userAgent)) {
        source = 'mobile_web';
    }

    if (/wv|WebView/i.test(userAgent)) {
        source = 'webview';
    }

    if (window.location.href.includes('telegram')) {
        source = 'telegram';
    } else if (window.location.href.includes('vk.com')) {
        source = 'vk';
    }

    return { operating_system, source };
}

document.addEventListener('click', function(event) {
    const button = event.target.closest('.slots__item-record[data-action]');
    if (!button) {
        return;
    }

    const card = button.closest('.slots__item');
    if (!card || button.dataset.reactHandled === 'true') {
        return;
    }

    const action = button.dataset.action;
    if (!['join', 'leave', 'leave_friend'].includes(action)) {
        return;
    }

    const gameId = card.dataset.gameid;
    const username = card.dataset.name;
    if (!gameId || !username) {
        return;
    }

    if (action === 'join' && card.dataset.isonlinepayment === 'True') {
        event.preventDefault();
        window.location.href = `/game/${gameId}/`;
        return;
    }

    event.preventDefault();
    button.classList.add('disabled');

    const apiPath = action === 'join'
        ? `/api/games/${gameId}/join/${username}/`
        : action === 'leave_friend'
            ? `/api/games/${gameId}/leave/${username}/friend/`
            : `/api/games/${gameId}/leave/${username}/`;
    const { operating_system, source } = getListingOsAndSource();
    const params = new URLSearchParams();
    if (operating_system) {
        params.append('operating_system', operating_system);
    }
    params.append('source', source);

    axios.get(`${apiPath}?${params.toString()}`)
        .then(res => {
            if (handleJoinRequiresAbonement(res)) {
                button.classList.remove('disabled');
                return;
            }

            if (res.data && res.data.message_type === 'danger') {
                window.alert(res.data.message);
                button.classList.remove('disabled');
                return;
            }

            window.location.reload();
        })
        .catch(error => {
            console.error('Listing action failed:', error);
            button.classList.remove('disabled');
        });
});


const gameContainer = document.querySelector('.game__block');

if (gameContainer) {

    let game = {
        timeFrame: gameContainer.dataset.timeframe,
        eventType: gameContainer.dataset.eventtype,
        gameType: gameContainer.dataset.gametype,
        buttonMessage: gameContainer.dataset.buttonmessage,
        playingField: gameContainer.dataset.playingfield,
        skill: gameContainer.dataset.skill,
        price: gameContainer.dataset.price,
        status: gameContainer.dataset.status,
        is_online_payment: gameContainer.dataset.isonlinepayment,
        email: gameContainer.dataset.email,
        lastname: gameContainer.dataset.lastname,
        userid: gameContainer.dataset.userid,
        coach: gameContainer.dataset.coach,
        cardPrice: gameContainer.dataset.cardprice,
        id: gameContainer.dataset.gameid,
        numberOfPlayers: parseInt(gameContainer.dataset.numberofplayers, 10),
        totalPlayersNum: parseInt(gameContainer.dataset.totalplayersnum, 10),
        totalPlayersQueuedNum: parseInt(gameContainer.dataset.totalplayersqueuednum, 10),
        totalPlayersWithPaymentNum: parseInt(gameContainer.dataset.totalplayerswithpaymentnum, 10),
        totalPlayersWithoutPaymentNum: parseInt(gameContainer.dataset.totalplayerswithoutpaymentnum, 10),
        isUser: (gameContainer.dataset.isuser == 'True' ? true : false),
        isJoiningAvailable: (gameContainer.dataset.isjoinavailable == 'True' ? true : false),
        canJoinFriend: (gameContainer.dataset.canjoinfriend == 'True' ? true : false),
        canRequestTrainingLevelApproval: (gameContainer.dataset.canrequesttraininglevelapproval == 'True' ? true : false),
        isUserJoined: (gameContainer.dataset.isuserjoined == 'True' ? true : false),
        isUserFriendJoined: (gameContainer.dataset.isuserfriendjoined == 'True' ? true : false),
        isUserPaid: (gameContainer.dataset.isuserpaid == 'True' ? true : false),
        isSelfRegAvailable: (gameContainer.dataset.isselfreg == 'True' ? true : false),
        isSelfRegAvailableForPlayer: (gameContainer.dataset.isselfregforplayer == 'True' ? true : false),
        isTrainingAdminJoiningAvailable: (gameContainer.dataset.isadminjoiningavailable == 'True' ? true : false),
        name: gameContainer.dataset.name,
        isofferaccepted: gameContainer.dataset.offer,
        isRandomRelations: (gameContainer.dataset.israndomrelations == 'True' ? true : false),
        isMorningOpen: (gameContainer.dataset.ismorningopen == 'True' ? true : false),
        isRandomRelationsMini: (gameContainer.dataset.israndomrelationsmini == 'True' ? true : false),
        isKingOfTheHill: (gameContainer.dataset.iskingofthehill == 'True' ? true : false),
        isMenLimited: (gameContainer.dataset.ismenlimited == 'True' ? true : false),
        isWomenLimited: (gameContainer.dataset.iswomenlimited == 'True' ? true : false),
        isTraining: (gameContainer.dataset.istraining == 'True' ? true : false),
        manPlayers: gameContainer.dataset.manplayers ? JSON.parse(gameContainer.dataset.manplayers) : [],
        manPlayersWithPayment: gameContainer.dataset.manplayerswithpayment ? JSON.parse(gameContainer.dataset.manplayerswithpayment) : [],
        manPlayersWithoutPayment: gameContainer.dataset.manplayerswithoutpayment ? JSON.parse(gameContainer.dataset.manplayerswithoutpayment) : [],
        womanPlayers: gameContainer.dataset.womanplayers ? JSON.parse(gameContainer.dataset.womanplayers) : [],
        womanPlayersWithPayment: gameContainer.dataset.womanplayerswithpayment ? JSON.parse(gameContainer.dataset.womanplayerswithpayment) : [],
        womanPlayersWithoutPayment: gameContainer.dataset.womanplayerswithoutpayment ? JSON.parse(gameContainer.dataset.womanplayerswithoutpayment) : [],
        players: gameContainer.dataset.players ? JSON.parse(gameContainer.dataset.players) : [],
        playersQueued: gameContainer.dataset.playersqueued ? JSON.parse(gameContainer.dataset.playersqueued) : [],
        playersWithPayment: gameContainer.dataset.playerswithpayment ? JSON.parse(gameContainer.dataset.playerswithpayment) : [],
        playersWithoutPayment: gameContainer.dataset.playerswithoutpayment ? JSON.parse(gameContainer.dataset.playerswithoutpayment) : [],
        playersWithMedals: gameContainer.dataset.playerswithmedals ? JSON.parse(gameContainer.dataset.playerswithmedals) : [],
        playersWithoutMedals: gameContainer.dataset.playerswithoutmedals ? JSON.parse(gameContainer.dataset.playerswithoutmedals) : [],
        isCompleted: (gameContainer.dataset.iscompleted == 'True' ? true : false),
        manPlayersWithMedals: gameContainer.dataset.manplayerswithmedals ? JSON.parse(gameContainer.dataset.manplayerswithmedals) : [],
        womanPlayersWithMedals: gameContainer.dataset.womanplayerswithmedals ? JSON.parse(gameContainer.dataset.womanplayerswithmedals) : [],
        manPlayersWithoutMedals: gameContainer.dataset.manplayerswithoutmedals ? JSON.parse(gameContainer.dataset.manplayerswithoutmedals) : [],
        womanPlayersWithoutMedals: gameContainer.dataset.womanplayerswithoutmedals ? JSON.parse(gameContainer.dataset.womanplayerswithoutmedals) : [],
        emptySlotsNum: function() {
            return this.numberOfPlayers - this.totalPlayersNum
        }
    };
    
    // Добавляем GuestBookingForm в глобальное пространство имен для iframe
    if (typeof window !== 'undefined') {
        window.GuestBookingForm = GuestBookingForm;
    }
    
    
    ReactDOM.render(<GameDetailsInnerRoot game={game} />, gameContainer);
}